import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

export interface UserData {
  name: string;
  email: string;
  language: string;
  timezone: string;
  spoken_languages: string[];
  roles: string[];
  permissions: string[];
}
export interface CreateUserMutationArguments {
  axios: AxiosInstance;
  userData: UserData;
}

async function updateUser(axios: AxiosInstance, userData: Partial<UserData>, userId: number): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/users/${userId}`, {
    ...userData,
  });
  return data;
}

export default function useUpdateUserMutation() {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userData, userId }: { userData: Partial<UserData>; userId: number }) => updateUser(axios, userData, userId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['OPUsers'],
      });
    },
  });
}
